/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import moment from 'moment';
import { debounce } from 'lodash';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
// custom component import
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import TextBoxRender from './gridComponents/TextBoxRender';
import SelectBoxRender from './gridComponents/SelectBoxRender';
import DatePickerRender from './gridComponents/DatePickerRender';
// custom function import
import {
  validDate,
  closeTab,
  focusToNextRowFirstCol,
  checkIfAmountNum,
  getCommonDropdownList,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  compareTwoDatesGreaterThanOrEqual,
  getDateTimeStamp,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  MinDate,
  tableGridHight330,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { logCheckTableHead, DropdownActions } from './gridComponents/tableHead';
import { onCellFocused } from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  setLogCheckTab,
  postSaveOrUpdate,
  getGeneralSystemParameterDetails,
  maintainLogCheckListData,
} from '../store/Actions';

function LogCheckComponent() {
  const dispatch = useDispatch();
  const history = useHistory();
  // dispatch function

  const addEditLogCheckTab = (data) => {
    return dispatch(setLogCheckTab(data));
  };
  // use Selector function
  const generalSystemParameterDetails = useSelector((state) => {
    return state.sharedState.CheckLogReducer.generalSystemParameter
      ?.paramGeneralVO;
  });
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const logCheckRowData = useSelector((state) => {
    return state.sharedState.CheckLogReducer.logCheckList;
  });
  const logCheckTabData = useSelector((state) => {
    return state.sharedState.CheckLogReducer.logCheckTabObj;
  });
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.CheckLogReducer.saveOrUpdateMessage;
  });
  const saveAfterDataList = useSelector((state) => {
    return state.sharedState.CheckLogReducer.saveAfterList;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData.sort(
      (a, b) => b.corrCommentId - a.corrCommentId
    );
  });

  // variable deceleration
  const gridRef = React.useRef();
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [permanentLogCheckList, setPermanentDeleteLogCheckList] =
    React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [spinnerLoader, setSpinnerLoader] = React.useState(false);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] =
    React.useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const [selectRowIndex, setSelectRowIndex] = React.useState(null);
  const [deletePopup, setDeletePopup] = React.useState(false);
  const [columnDefs, setColumnDefs] = React.useState(logCheckTableHead);
  const [selectionRow, setSelectionRow] = React.useState({});
  const [saveAfterData, setSaveAfterData] = React.useState([]);
  const [selectRow, setSelectRow] = React.useState({});
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [keyValue, setKeyValue] = React.useState([]);
  const [commonDropdownList, setCommonDropdownList] = React.useState({});
  const [rowGridPrimaryKey, setRowGridPrimaryKey] = React.useState('');
  const [gridApi, setGridApi] = React.useState(null);
  let gridParams = null;

  const addNewRowLogCheckList = (data, action) => {
    return dispatch(maintainLogCheckListData(data, action));
  };
  // on scroll default top level
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: [
        'CHECK_PAYEE_CD',
        'PAYMENT_MEDIA_TYPE_CD',
        'DISPUTE_RESOLUTION_CD',
      ],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);
  // Add new row on ag-Grid table
  const addDefaultRow = (action) => {
    setDisabledSaveCancelBtn(true);
    setErrorMessages([]);
    setSuccessMessage([]);
    if (
      (logCheckRowData && logCheckRowData?.length == 0) ||
      action === 'clear'
    ) {
      addNewRowLogCheckList(
        {
          checkLogNum: null,
          corrLinkId: null,
          actionVal: 0,
          batchNum: '',
          batchDt: null,
          checkIdentifier: '',
          checkNum: '',
          checkIssuer: '',
          checkInfo: '',
          checkDt: null,
          postmarkedDt: null,
          receivedDt: null,
          checkAmt: parseFloat(0).toFixed(2),
          checkPayeeCd: UserDefaultValues?.checkPayeeCd
            ? UserDefaultValues?.checkPayeeCd
            : '-1',
          paymentMediaTypeCd: 'Check',
          disputeResolutionCd: 'N',
          batchNumErr: false,
          batchDateErr: false,
          checkIndentifierErr: false,
          checkNumErr: false,
          checkIssuerErr: false,
          checkInfoErr: false,
          checkDateErr: false,
          postMarkedDateErr: false,
          receivedDateErr: false,
          receivedDatePopUp: false,
          checkAmtErr: false,
          checkPayeeCDErr: false,
          paymentMediaTypeCDErr: false,
          disputeResolutionCDErr: false,
          isYes: false,
          isAddedFromUI: false,
          checkAmtActiveCursor: false,
          checkPayeeCDActiveCursor: false,
          paymentMediaTypeCDActiveCursor: false,
          disputeResolutionCDActiveCursor: false,
        },
        'defaultRow'
      );
    }
  };

  // handing refresh functionality
  React.useEffect(() => {
    if (
      (logCheckTabData && Object.keys(logCheckTabData).length === 0) ||
      logCheckTabData === null
    ) {
      dispatch(getGeneralSystemParameterDetails());

      addDefaultRow();
    } else {
      const tempObj = logCheckTabData;
      if (tempObj && tempObj.fullScreenView)
        setFullScreenView(tempObj.fullScreenView);
      if (tempObj && tempObj.permanentLogCheckList)
        setPermanentDeleteLogCheckList(tempObj.permanentLogCheckList);
      if (tempObj && tempObj.disabledSaveCancelBtn)
        setDisabledSaveCancelBtn(tempObj.disabledSaveCancelBtn);
      if (tempObj && tempObj.saveAfterData)
        setSaveAfterData(tempObj.saveAfterData);
      if (tempObj && tempObj.selectRowIndex)
        setSelectRowIndex(tempObj.selectRowIndex);
      if (tempObj && tempObj.selectionRow)
        setSelectionRow(tempObj.selectionRow);
      setErrorMessages(tempObj && tempObj.errorMessages);
    }
  }, [logCheckTabData]);
  // handle system parameters
  React.useEffect(() => {
    let tableHead = [];
    tableHead =
      columnDefs &&
      columnDefs.filter((x) => {
        if (
          generalSystemParameterDetails?.length > 0 &&
          parseInt(
            generalSystemParameterDetails[0].checkLogUsesBatchInd,
            [0, 1]
          ) === 0
        ) {
          return x.field !== 'batchNum';
        }
        return x;
      });
    setColumnDefs(tableHead);
  }, [generalSystemParameterDetails]);
  // handle after call service show success and error message
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      let tempObj = [];
      const updateRowData =
        saveOrUpdateMessage &&
        saveOrUpdateMessage.data &&
        saveOrUpdateMessage.data.saveLogCheckResponseVO;
      if (updateRowData && updateRowData.length > 0 && !disabledSaveCancelBtn) {
        tempObj =
          logCheckRowData &&
          logCheckRowData.map((item, index) => {
            if (item.checkLogNum === updateRowData[index].checkLogNum) {
              item.isAddedFromUI = true;
              item.corrLinkId = updateRowData[index].corrLinkId;
            }
            return item;
          });
        setSaveAfterData(tempObj);
        addNewRowLogCheckList(tempObj, 'verify');
        addEditLogCheckTab({
          disabledSaveCancelBtn: true,
          saveAfterData: tempObj,
          errorMessages: [],
        });
      }
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      if (!clickOncloseTabBtn) {
        dispatch(postSaveOrUpdate(null));
        addNewRowLogCheckList(null);
        addEditLogCheckTab({});
        closeTab('/log-check', history, dispatch);
      } else {
        setSpinnerLoader(false);
        setDisabledSaveCancelBtn(true);
        const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
        const newObj1 =
          updateTabs &&
          updateTabs.length > 0 &&
          updateTabs.map((item) => {
            if (item.navTo === '/log-check') {
              item.isFormSave = false;
              item.isFormDirty = false;
              item.isFormError = false;
            }
            return item;
          });
        localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
      }
    } else if (saveOrUpdateMessage === 'failed') {
      setErrorMessages([constantMessageData.FAILED_MESSAGE_GENERIC]);
      setSuccessMessage([]);
      setSpinnerLoader(false);
      setSaveAfterData([]);
      setDisabledSaveCancelBtn(true);
    }
  }, [saveOrUpdateMessage]);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj =
        logCheckRowData &&
        logCheckRowData?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      addNewRowLogCheckList(tempObj, 'verify');
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    }
  }, [commentsList]);
  // handing highlight tab
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (logCheckTabData && Object.keys(logCheckTabData).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/log-check' && !disabledSaveCancelBtn) {
            item.isFormDirty = true;
            if (
              logCheckTabData.errorMessages &&
              logCheckTabData.errorMessages.length > 0
            ) {
              item.isFormError = true;
            } else {
              item.isFormError = false;
            }
          } else if (item.navTo === '/log-check') item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [logCheckTabData || setDisabledSaveCancelBtn]);
  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.forEachNode(
      (node) =>
        node.rowIndex === logCheckTabData.selectRowIndex &&
        node.setSelected(true)
    );
    gridParams = params;
  };

  // click on filter icon after call
  const handleClearFilter = () => {
    gridRef.current.clearFilters();
  };

  // click on add button after call
 const fetchDataFromServer = (data) => {
    const newObj = {
      checkLogNum: null,
      corrLinkId: null,
      batchNum: data && data.batchNum ? data.batchNum : '',
      actionVal: 0,
      batchDt: data && data.batchDt ? data.batchDt : null,
      checkIdentifier: '',
      checkNum: '',
      checkIssuer: '',
      checkInfo: '',
      checkDt: null,
      postmarkedDt: null,
      receivedDt: null,
      checkAmt: '',
      checkPayeeCd: data && data.checkPayeeCd ? data.checkPayeeCd : null,
      paymentMediaTypeCd:data && data.paymentMediaTypeCd ? data.paymentMediaTypeCd : null,
      disputeResolutionCd: 'N',
      batchNumErr: false,
      batchDateErr: false,
      checkIndentifierErr: false,
      checkNumErr: false,
      checkIssuerErr: false,
      checkInfoErr: false,
      checkDateErr: false,
      postMarkedDateErr: false,
      receivedDateErr: false,
      receivedDatePopUp: false,
      checkAmtErr: false,
      checkPayeeCDErr: false,
      paymentMediaTypeCDErr: false,
      disputeResolutionCDErr: false,
      isYes: false,
      isAddedFromUI: false,
      checkAmtActiveCursor: false,
      checkPayeeCDActiveCursor: false,
      paymentMediaTypeCDActiveCursor: false,
      disputeResolutionCDActiveCursor: false,
      rowWithNewChange: true,
      batchNumActiveCursor: true,
    };
    addNewRowLogCheckList(newObj);
    handleClearFilter();
    focusToNextRowFirstCol(gridParams, 2);
  };
  // check all row validation on ag-Grid table
  const validateRequest = (data) => {
  handleClearFilter();
  setDisabledSaveCancelBtn(false);
  let showErr = false;
  setErrorMessages([]);
  setSuccessMessage([]);
  const errorMessagesArray = [];
  const newObj = [...data];

  // Helper to strictly validate dates
  const isValidDate = (dateStr) => {
    const d = new Date(dateStr);
    return d instanceof Date && !isNaN(d.getTime());
  };

  // Loop through all rows
  for (let i = 0; i < newObj.length; i++) {
    const row = newObj[i];

    // --- CHECK ISSUER ---
    if (!row.checkIssuer) {
      showErr = true;
      row.checkIssuerErr = true;
      errorMessagesArray.push(`${constantMessageData.CHECK_ISSUE_REQUIRED} [${row.checkLogNum}].`);
    }

    // --- RECEIVED DATE ---
    if (!row.receivedDt) {
      showErr = true;
      row.receivedDateErr = true;
      errorMessagesArray.push(`${constantMessageData.RECEIVED_DATE_REQUIRED} [${row.checkLogNum}].`);
    } else if (!isValidDate(row.receivedDt)) {
      showErr = true;
      row.receivedDateErr = true;
      errorMessagesArray.push(`${constantMessageData.DATE_INVALID_FORMAT_ERROR} [${row.checkLogNum}].`);
    } else if (compareTwoDatesGreaterThanOrEqual(new Date(row.receivedDt), moment(MinDate))) {
      showErr = true;
      row.receivedDateErr = true;
      errorMessagesArray.push(`${constantMessageData.RECEIVED_DATE_LESS_THAN_ERROR} [${row.checkLogNum}].`);
    } else if (compareTwoDatesGreaterThanOrEqual(new Date(), moment(row.receivedDt))) {
      showErr = true;
      row.receivedDateErr = true;
      errorMessagesArray.push(`Received Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR} [${row.checkLogNum}].`);
    }

    // --- BATCH DATE ---
    if (row.batchDt) {
      if (!isValidDate(row.batchDt)) {
        showErr = true;
        row.batchDateErr = true;
        errorMessagesArray.push(`${constantMessageData.DATE_INVALID_FORMAT_ERROR} [${row.checkLogNum}].`);
      } else if (compareTwoDatesGreaterThanOrEqual(new Date(row.batchDt), moment(MinDate))) {
        showErr = true;
        row.batchDateErr = true;
        errorMessagesArray.push(`${constantMessageData.BATCH_DATE_LESS_THAN_ERROR} [${row.checkLogNum}].`);
      } else if (compareTwoDatesGreaterThanOrEqual(new Date(), moment(row.batchDt))) {
        showErr = true;
        row.batchDateErr = true;
        errorMessagesArray.push(`Batch Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR} [${row.checkLogNum}].`);
      }
    }

    // --- CHECK DATE ---
    if (row.checkDt) {
      if (!isValidDate(row.checkDt)) {
        showErr = true;
        row.checkDateErr = true;
        errorMessagesArray.push(`${constantMessageData.DATE_INVALID_FORMAT_ERROR} [${row.checkLogNum}].`);
      } else if (compareTwoDatesGreaterThanOrEqual(new Date(row.checkDt), moment(MinDate))) {
        showErr = true;
        row.checkDateErr = true;
        errorMessagesArray.push(`${constantMessageData.CHECK_DATE_LESS_THAN_ERROR} [${row.checkLogNum}].`);
      } else if (compareTwoDatesGreaterThanOrEqual(new Date(), moment(row.checkDt))) {
        showErr = true;
        row.checkDateErr = true;
        errorMessagesArray.push(`Check Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR} [${row.checkLogNum}].`);
      }
    }

    // --- POSTMARK DATE ---
    if (row.postmarkedDt) {
      if (!isValidDate(row.postmarkedDt)) {
        showErr = true;
        row.postMarkedDateErr = true;
        errorMessagesArray.push(`${constantMessageData.DATE_INVALID_FORMAT_ERROR} [${row.checkLogNum}].`);
      } else if (compareTwoDatesGreaterThanOrEqual(new Date(row.postmarkedDt), moment(MinDate))) {
        showErr = true;
        row.postMarkedDateErr = true;
        errorMessagesArray.push(`${constantMessageData.POSTMARK_DATE_LESS_THAN_ERROR} [${row.checkLogNum}].`);
      } else if (compareTwoDatesGreaterThanOrEqual(new Date(), moment(row.postmarkedDt))) {
        showErr = true;
        row.postMarkedDateErr = true;
        errorMessagesArray.push(`Postmark/ EFT Transmittal Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR} [${row.checkLogNum}].`);
      }
    }

    // --- CHECK AMOUNT ---
    if (!row.checkAmt) {
      showErr = true;
      row.checkAmtErr = true;
      errorMessagesArray.push(`${constantMessageData.CHECK_AMOUNT_REQUIRED} [${row.checkLogNum}].`);
    } else if (Number.isNaN(parseFloat(row.checkAmt)) || !checkIfAmountNum(row.checkAmt)) {
      showErr = true;
      row.checkAmtErr = true;
      errorMessagesArray.push(`${constantMessageData.CHECK_AMOUNT_ALLOW_NUMBER_REQUIRED} [${row.checkLogNum}].`);
    } else if (parseFloat(row.checkAmt) === 0) {
      showErr = true;
      row.checkAmtErr = true;
      errorMessagesArray.push(`${constantMessageData.CHECK_AMOUNT_NON_ZERO_REQUIRED} [${row.checkLogNum}].`);
    }

    // --- CHECK PAYEE ---
    if (!row.checkPayeeCd || row.checkPayeeCd === '-1') {
      showErr = true;
      row.checkPayeeCDErr = true;
      errorMessagesArray.push(`${constantMessageData.CHECK_PAYEE_REQUIRED} [${row.checkLogNum}].`);
    }

    // Update row in Redux
    addNewRowLogCheckList(newObj, 'verify');
  }

  // --- FINALIZE ERRORS ---
  if (showErr) {
    setErrorMessages([...new Set(errorMessagesArray)]);
    setSuccessMessage([]);
    addEditLogCheckTab({
      ...logCheckTabData,
      errorMessages: [...new Set(errorMessagesArray)],
      successMessages: [],
    });
    return false;
  }

  // Clear errors if none
  setErrorMessages([]);
  setSuccessMessage([]);
  addEditLogCheckTab({
    ...logCheckTabData,
    errorMessages: [],
    successMessages: [],
  });
  return true;
};
  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    const data = [...logCheckRowData];
    if (validateRequest(data)) {
      setErrorMessages([]);
      setSuccessMessage([]);
      openSave(value);
    } else {
      handleScrollToEvent();
    }
  };
  // handle save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // cancel popup
  const handelCancelClose = () => {
    setOpenCancel(false);
  };
  // click on yes button after call
  const masterDataSave = () => {
    handleSaveClose();
    handelCancelClose();
    setSpinnerLoader(true);
    const addEditLogCheckList = logCheckRowData
      .filter((x) => x.rowWithNewChange)
      .map((item) => {
        return {
          checkLogNum: item.checkLogNum,
          batchNum: item.batchNum,
          batchDt: item.batchDt
            ? moment.utc(item.batchDt).format('MM/DD/YYYY')
            : null,
          checkIdentifier: item.checkIdentifier,
          checkNum: item.checkNum,
          checkIssuer: item.checkIssuer,
          checkInfo: item.checkInfo,
          checkDt: item.checkDt
            ? moment.utc(item.checkDt).format('MM/DD/YYYY')
            : null,
          postmarkedDt: item.postmarkedDt
            ? moment.utc(item.postmarkedDt).format('MM/DD/YYYY')
            : null,
          receivedDt: item.receivedDt
            ? moment.utc(item.receivedDt).format('MM/DD/YYYY')
            : null,
          checkAmt: parseFloat(item.checkAmt),
          checkPayeeCd: item.checkPayeeCd !== '-1' ? item.checkPayeeCd : null,
          paymentMediaTypeCd:
            item.paymentMediaTypeCd !== '-1' ? item.paymentMediaTypeCd : null,
          disputeResolutionCd:
            item.disputeResolutionCd !== '-1' ? item.disputeResolutionCd : null,
          lastUpdateUserId: UserDefaultValues?.userId,
          insertedDt: getDateTimeStamp(new Date()),
        };
      });
    const deleteRowList =
      permanentLogCheckList && permanentLogCheckList.length > 0
        ? permanentLogCheckList
            .filter((x) => {
              return x.isAddedFromUI;
            })
            .map((prop) => {
              return {
                checkLogNum: prop.checkLogNum,
              };
            })
        : [];
    const saveRequest = {
      logCheckSaveVOList: addEditLogCheckList,
      logCheckDeleteVOList: deleteRowList,
    };
    dispatch(postSaveOrUpdate(saveRequest));
    setSaveAfterData([]);
    handleScrollToEvent();
  };
  // handle close and confirm popup
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      dispatch(postSaveOrUpdate(null));
    }
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/log-check' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/log-check' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // reset All fields
  const resetAllFields = () => {
    handelCancelClose();
    setErrorMessages([]);
    setSuccessMessage([]);
    setDisabledSaveCancelBtn(true);
    if (saveAfterDataList && saveAfterDataList.length > 0) {
      addNewRowLogCheckList([], 'verify');
      const newObjList =
        saveAfterData &&
        saveAfterData.map((item, index) => {
          if (
            saveAfterDataList &&
            saveAfterDataList.length > 0 &&
            saveAfterDataList.filter((x) => {
              return x.checkLogNum === item.checkLogNum;
            }).length > 0
          ) {
            item.isAddedFromUI = true;
            item.batchNum = saveAfterDataList[index].batchNum;
            item.batchDt = saveAfterDataList[index].batchDt;
            item.checkIdentifier = saveAfterDataList[index].checkIdentifier;
            item.checkNum = saveAfterDataList[index].checkNum;
            item.checkIssuer = saveAfterDataList[index].checkIssuer;
            item.checkInfo = saveAfterDataList[index].checkInfo;
            item.checkDt = saveAfterDataList[index].checkDt;
            item.postmarkedDt = saveAfterDataList[index].postmarkedDt;
            item.receivedDt = saveAfterDataList[index].receivedDt;
            item.checkAmt = saveAfterDataList[index].checkAmt;
            item.checkPayeeCd = saveAfterDataList[index].checkPayeeCd;
            item.paymentMediaTypeCd =
              saveAfterDataList[index].paymentMediaTypeCd;
            item.disputeResolutionCd =
              saveAfterDataList[index].disputeResolutionCd;
            item.batchNumErr = false;
            item.batchDateErr = false;
            item.checkIndentifierErr = false;
            item.checkNumErr = false;
            item.checkIssuerErr = false;
            item.checkInfoErr = false;
            item.checkDateErr = false;
            item.postMarkedDateErr = false;
            item.receivedDateErr = false;
            item.receivedDatePopUp = false;
            item.checkAmtErr = false;
            item.checkPayeeCDErr = false;
            item.paymentMediaTypeCDErr = false;
            item.disputeResolutionCDErr = false;
            item.isYes = false;
            item.checkAmtActiveCursor = false;
            item.checkPayeeCDActiveCursor = false;
            item.paymentMediaTypeCDActiveCursor = false;
            item.disputeResolutionCDActiveCursor = false;
          }
          return item;
        });
    //  setTimeout(() => 
        const debouncedAddNewRow = debounce(() => {
          if (newObjList && newObjList.length > 0) {
            addNewRowLogCheckList(newObjList, 'verify');
          }
        });
        debouncedAddNewRow();
    //  100);
      addEditLogCheckTab({
        saveAfterData: newObjList,
        disabledSaveCancelBtn: true,
      });
    } else {
      addEditLogCheckTab({});
      addDefaultRow('clear');
    }
    handleScrollToEvent();
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/log-check') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };

  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };

  // click on full screen icon after call
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    addEditLogCheckTab({
      ...logCheckTabData,
      fullScreenView: !fullScreenView,
    });
  };
  // click on view batch total option
  const logBatchTotalScreen = () => {
    redirectURLLink('/logBatchSearch', 'Log Batch Totals', history, dispatch);
  };
  // click on delete option
  const deleteSelectRowData = (data) => {
    setDeletePopup(false);
    setDisabledSaveCancelBtn(false);
    handleClearFilter();
    setSelectionRow({});
    const newObj = [...logCheckRowData];
    if (newObj && newObj.length > 0) {
      const key = newObj.findIndex((item) => {
        return item.checkLogNum == data.checkLogNum;
      });
      newObj.splice(key, 1);
      addNewRowLogCheckList(newObj, 'verify');
      errorMessages &&
        errorMessages.length > 0 &&
        errorMessages.map((item, key) => {
          if (
            item.includes(constantMessageData.DATE_INVALID_FORMAT_ERROR) &&
            newObj &&
            newObj.length > 0 &&
            newObj.filter((x) => {
                return (
                  x.receivedDateErr ||
                  x.batchDateErr ||
                  x.checkDateErr ||
                  x.postMarkedDateErr
                );
              }).length === 0
          ) {
            return (
              errorMessages.splice(key, 1),
              setErrorMessages([...new Set(errorMessages)]),
              addEditLogCheckTab({
                ...logCheckTabData,
                disabledSaveCancelBtn: false,
                selectionRow: {},
                selectRowIndex: null,
                errorMessages: [...new Set(errorMessages)],
              })
            );
          }
        });
      const Obj = permanentLogCheckList;
      Obj.push(data);
      setSuccessMessage([]);
      setPermanentDeleteLogCheckList(Obj);
      addEditLogCheckTab({
        ...logCheckTabData,
        disabledSaveCancelBtn: false,
        successMessages: [],
        selectionRow: {},
        selectRowIndex: null,
        permanentLogCheckList: Obj,
      });
    }
    if (newObj && newObj.length > 0) {
      const temErrorMsg =
        errorMessages &&
        errorMessages.length > 0 &&
        errorMessages.filter((x) => {
          return !x.includes(data.checkLogNum);
        });
      if (temErrorMsg && Array.isArray(temErrorMsg)) {
        setErrorMessages([...new Set(temErrorMsg)]);
        addEditLogCheckTab({
          ...logCheckTabData,
          selectionRow: {},
          selectRowIndex: null,
          errorMessages: [...new Set(temErrorMsg)],
        });
      }
    } else {
      setErrorMessages([]);
      addEditLogCheckTab({
        ...logCheckTabData,
        disabledSaveCancelBtn: false,
        selectionRow: {},
        selectRowIndex: null,
        errorMessages: [],
      });
    }
  };
  // click on view history icon after call
  const handleViewHistory = (gridApi) => {
    const checkLogNum = gridApi.getSelectedRows()?.[0]?.checkLogNum;
    setShowViewHistory(true);
    setKeyValue({ CHECK_LOG_NUM: checkLogNum || null });
  };
  // handle click on add new check button after call
   const handleAddNewRow = (params) => {
    gridParams = params;
    if (logCheckRowData && logCheckRowData.length > 0) {
      if (validateRequest(logCheckRowData)) {
        const tempObj = {
          checkLogNum: null,
          corrLinkId: null,
          actionVal: 0,
          batchNum: '',
          batchDt: null,
          checkIdentifier: '',
          checkNum: '',
          checkIssuer: '',
          checkInfo: '',
          checkDt: null,
          postmarkedDt: null,
          receivedDt: null,
          checkAmt: '',
          checkPayeeCd: 'MD',
          paymentMediaTypeCd: 'Check',
          disputeResolutionCd: 'N',
        };
        fetchDataFromServer(
          Object.keys(selectionRow).length > 0 ? selectionRow : tempObj
        );
      }
    } else {
      addDefaultRow('clear');
      focusToNextRowFirstCol(params, 2);
    }
  };
  // check validation on blur event
  const handleOnblurEvent = () => {
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    addEditLogCheckTab({
      ...logCheckTabData,
      disabledSaveCancelBtn: false,
      successMessages: [],
    });
  };
  // handle tab to next cell logic
  const tabToNextCell = (params) => {
    const { previousCellPosition, nextCellPosition, api } = params;

    const isLastRow =
      previousCellPosition.rowIndex === api.getModel().getRowCount() - 1;
    const isLastColumn =
      previousCellPosition.column.getColId() === 'disputeResolutionCd';

    if (isLastRow && isLastColumn) {
      if (validateRequest(logCheckRowData)) {
        const tempObj = {
          checkLogNum: null,
          corrLinkId: null,
          actionVal: 0,
          batchNum: '',
          batchDt: null,
          checkIdentifier: '',
          checkNum: '',
          checkIssuer: '',
          checkInfo: '',
          checkDt: null,
          postmarkedDt: null,
          receivedDt: null,
          checkAmt: '',
          checkPayeeCd: 'MD',
          paymentMediaTypeCd: 'Check',
          disputeResolutionCd: 'N',
        };
        fetchDataFromServer(
          Object.keys(selectionRow).length > 0 ? selectionRow : tempObj
        );
        return null;
      } else {
        if (gridRef.current && gridRef.current.totalResultsRef) {
          gridRef.current.totalResultsRef.current.focus();
        }
        return null;
      }
    }
    return nextCellPosition;
  };

  return (
    <div data-testid="log_check">
      <div className="tabs-container">
        <div className="tBillPanel custom-check">
          <div className="paneldevider-line">
            <SaveCancelPopup
              open={open}
              data-testid="savePopup"
              title="Save"
              onConfim={() => {
                masterDataSave();
              }}
              onCancel={() => {
                handleSaveClose();
              }}
            />
            <SaveCancelPopup
              open={openCancel}
              data-testid="cancelPopup"
              title="Cancel"
              onConfim={() => {
                resetAllFields();
              }}
              onCancel={() => {
                handelCancelClose();
              }}
            />
            <SaveCancelPopup
              open={deletePopup}
              data-testid="deletePopup"
              title="Delete"
              moduleName="the selected record"
              onConfim={() => {
                deleteSelectRowData(selectRow);
              }}
              onCancel={() => {
                setDeletePopup(false);
              }}
            />
            <Spinner load={spinnerLoader} />
            <div className="panel">
              {!fullScreenView && (
                <>
                  <CustomSeparator parent1="Tasks" parent2="Log Check" />
                  <DisplayErrorMessages
                    errorMessages={
                      errorMessages && errorMessages.length > 0
                        ? [...new Set(errorMessages)]
                        : []
                    }
                  />
                  {errorMessages && errorMessages.length === 0 && (
                    <DisplaySuccessMessages successMessages={successMessages} />
                  )}
                  <div className="flex-block justify-end pb-1">
                    <div className="btn-wrapper float-right">
                      <Button
                        className="btn btn-success btn-save"
                        data-testid="saveBtn"
                        disabled={disabledSaveCancelBtn}
                        onClick={() => {
                          const tempObj =
                            logCheckRowData &&
                            logCheckRowData.length > 0 &&
                            logCheckRowData.map((item) => {
                              item.checkPayeeCDActiveCursor = false;
                              item.paymentMediaTypeCDActiveCursor = false;
                              item.disputeResolutionCDActiveCursor = false;
                              return item;
                            });
                          addNewRowLogCheckList(tempObj, 'verify');
                          onSubmit(true);
                        }}
                      >
                        {' '}
                        <SVGComponent iconName="Icon-awesome-save" />
                        Save
                      </Button>

                      <Button
                        className="btn btn-cancel"
                        data-testid="cancelBtn"
                        onClick={() => {
                          const tempObj =
                            logCheckRowData &&
                            logCheckRowData.length > 0 &&
                            logCheckRowData.map((item) => {
                              item.checkPayeeCDActiveCursor = false;
                              item.paymentMediaTypeCDActiveCursor = false;
                              item.disputeResolutionCDActiveCursor = false;
                              return item;
                            });
                          addNewRowLogCheckList(tempObj, 'verify');
                          handleOpenClose();
                        }}
                        disabled={disabledSaveCancelBtn}
                      >
                        <SVGComponent iconName="Icon-cancel" />
                        Cancel
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk"
            >
              {commonDropdownList &&
              Object.keys(commonDropdownList)?.length > 0 ? (
                <TableGrid
                  ref={gridRef}
                  tabToNextCell={tabToNextCell}
                  enableFocusOnFirstRender ={true}//  for first row default selection
                  selectRowIndex={0}   // required to send to grid to set index of default row selected
                  focusColId="batchNum"   // required to set the default focus cell
                  gridCall={onGridReady}
                  gridHeight={fullScreenView ? '70vh' : tableGridHight330}
                  rowData={
                    logCheckRowData &&
                    logCheckRowData?.map((item) => {
                      const firstDropdownVal =
                        commonDropdownList?.CHECK_PAYEE_CD?.filter((x) => {
                          return (
                            x.codeValueID &&
                            x.codeValueID?.codeValue === item.checkPayeeCd
                          );
                        });
                      if (firstDropdownVal && firstDropdownVal.length > 0) {
                        item.checkPayeeCdValWithLabel = `${
                          firstDropdownVal[0].codeValueID &&
                          firstDropdownVal[0].codeValueID.codeValue
                        } - ${firstDropdownVal[0].shortDescription}`;
                      } else {
                        item.checkPayeeCdValWithLabel = null;
                      }
                      const secondDropDownVal =
                        commonDropdownList?.PAYMENT_MEDIA_TYPE_CD?.filter(
                          (x) => {
                            return (
                              x.codeValueID &&
                              x.codeValueID?.codeValue ===
                                item.paymentMediaTypeCd
                            );
                          }
                        );
                      if (secondDropDownVal && secondDropDownVal.length > 0) {
                        item.paymentMediaTypeCdValWithLabel = `${
                          secondDropDownVal[0].codeValueID &&
                          secondDropDownVal[0].codeValueID.codeValue
                        } - ${secondDropDownVal[0].shortDescription}`;
                      } else {
                        item.checkPayeeCdValWithLabel = null;
                      }
                      const thirdDropDownVal =
                        commonDropdownList?.DISPUTE_RESOLUTION_CD?.filter(
                          (x) => {
                            return (
                              x.codeValueID &&
                              x.codeValueID?.codeValue ===
                                item.disputeResolutionCd
                            );
                          }
                        );
                      if (thirdDropDownVal && thirdDropDownVal.length > 0) {
                        item.disputeResolutionCdValWithLabel = `${
                          thirdDropDownVal[0].codeValueID &&
                          thirdDropDownVal[0].codeValueID.codeValue
                        } - ${thirdDropDownVal[0].shortDescription}`;
                      } else {
                        item.disputeResolutionCdValWithLabel = null;
                      }
                      return item;
                    })
                  }
                  columnDefs={
                    columnDefs &&
                    columnDefs.filter((x) => {
                      if (
                        generalSystemParameterDetails?.length > 0 &&
                        parseInt(
                          generalSystemParameterDetails[0].checkLogByCcnInd
                        ) === 0
                      ) {
                        return x.headerName !== 'CCN';
                      }
                      return x;
                    })
                  }
                  fullScreenView={fullScreenView}
                  handleFullScreenViewClick={handleFullScreenView}
                  //handleViewHistory={handleViewHistory}
                  applyFilter={false}
                  isScrollOn
                  exportFile
                  helpMessage=""
                  data-testid="onEditingStopped"
                  fileName="Log Check"
                  onCellValueChanged={handleOnblurEvent}
                  addButtonText="Add Check"
                  onSelectionChanged={(val) => {
                    const rowData = val.api.getSelectedRows()[0];
                    if (rowData && Object.keys(rowData).length > 0) {
                      setSelectionRow(rowData);
                      setSelectRowIndex(
                        logCheckRowData.findIndex((x) => {
                          return x.checkLogNum === rowData.checkLogNum;
                        })
                      );
                      addEditLogCheckTab({
                        ...logCheckTabData,
                        selectionRow: rowData,
                        disabledSaveCancelBtn: disabledSaveCancelBtn,
                        selectRowIndex: logCheckRowData.findIndex((x) => {
                          return x.checkLogNum === rowData.checkLogNum;
                        }),
                      });
                    }
                  }}
                  handleAddNewRow={handleAddNewRow}
                  singleClickEdit
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                  frameworkComponents={{
                    ActionCellRender: (cellInfo) => {
                      const logCheckRowData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckList;
                      });
                      const logCheckTabData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckTabObj;
                      });
                      const generalSystemParameterDetails = useSelector(
                        (state) => {
                          return state.sharedState.CheckLogReducer
                            .generalSystemParameter?.paramGeneralVO;
                        }
                      );
                      return (
                        <div
                          className="tdCell icon-btn-group"
                          data-testid="action-column"
                        >
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="add-tooltip">Add Check</Tooltip>
                            }
                          >
                            <Button
                              className="float-left"
                              data-testid="add-new-log-check"
                              aria-label="Add new log check"
                              variant="text"
                              onClick={() => {
                                const tempObj = logCheckRowData?.map((item) => {
                                  item.checkPayeeCDActiveCursor = false;
                                  item.paymentMediaTypeCDActiveCursor = false;
                                  item.disputeResolutionCDActiveCursor = false;
                                  return item;
                                });
                                addNewRowLogCheckList(tempObj, 'verify');
                                if (validateRequest(logCheckRowData)) {
                                  fetchDataFromServer(cellInfo.data);
                                }
                              }}
                            >
                              <SVGComponent iconName="Icon-addCircle" />{' '}
                            </Button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="com-tooltip">Comment</Tooltip>
                            }
                          >
                            {!(cellInfo && cellInfo.data.isAddedFromUI) ? (
                              <Button
                                disabled
                                type="button"
                                aria-label="comment"
                                onClick={() => {
                                  const errorArray = [];
                                  errorArray.push(
                                    constantMessageData.WITHOUT_SAVE_ADD_COMMENT_ERROR
                                  );
                                  setErrorMessages([...new Set(errorArray)]);
                                  setDisabledSaveCancelBtn(false);
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    errorMessages: errorArray,
                                    disabledSaveCancelBtn: false,
                                  });
                                }}
                                className="th-ic comment-ic frr-disabled-comment-btn"
                                variant="text"
                              >
                                <img alt="comments" src={CommentIcon} />
                              </Button>
                            ) : (
                              <Button
                                onClick={() => {
                                  setCorrLinkId(cellInfo.data.corrLinkId);
                                  setRowGridPrimaryKey(
                                    cellInfo.data.checkLogNum
                                  );
                                  setShowComments(true);
                                }}
                                tabIndex={'0'}
                                onKeyDown={(e) => {
                                  // Handle Enter and Space key events
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault(); // Prevents the default space scrolling behavior
                                    setCorrLinkId(cellInfo.data?.corrLinkId);
                                    setShowComments(true);
                                  }
                                }}
                                className={`th-ic comment-ic ${
                                  parseInt(
                                    cellInfo.data.ccCommentsExist,
                                    [0, 1]
                                  ) === 1
                                    ? 'frr-enabled-comment-btn'
                                    : 'frr-disabled-comment-btn'
                                }`}
                                variant="text"
                              >
                                {parseInt(
                                  cellInfo.data.ccCommentsExist,
                                  [0, 1]
                                ) === 1 ? (
                                  <img alt="" src={CommentVisibleIcon} />
                                ) : (
                                  <img alt="" src={CommentIcon} />
                                )}
                              </Button>
                            )}
                          </OverlayTrigger>
                          <div className="icon-dropdown-container">
                            <DropdownActions
                              generalSystemParameterDetails={
                                generalSystemParameterDetails
                              }
                              logBatchTotalScreen={logBatchTotalScreen}
                              deleteAction={() => {
                                const tempObj =
                                  logCheckRowData &&
                                  logCheckRowData.length > 0 &&
                                  logCheckRowData.map((item) => {
                                    item.checkPayeeCDActiveCursor = false;
                                    item.paymentMediaTypeCDActiveCursor = false;
                                    item.disputeResolutionCDActiveCursor = false;
                                    return item;
                                  });
                                addNewRowLogCheckList(tempObj, 'verify');
                                setDeletePopup(true);
                                setSelectRow(cellInfo.data);
                              }}
                            />
                          </div>
                        </div>
                      );
                    },
                    BatchNumCellRender: TextBoxRender,
                    CheckNumCellRender: TextBoxRender,
                    CheckIdentifierCellRender: TextBoxRender,
                    CheckIssuerCellRender: (cellInfo) => {
                      const logCheckRowData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckList;
                      });
                      const logCheckTabData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckTabObj;
                      });
                      const handleOnblurEventCheckIssue = () => {
                        const errorArray =
                          logCheckTabData.errorMessages &&
                          logCheckTabData.errorMessages.length > 0
                            ? logCheckTabData.errorMessages
                            : [];
                        if (
                          logCheckRowData &&
                          logCheckRowData.length > 0 &&
                          logCheckRowData.filter((x) => {
                            return x.checkIssuerErr;
                          }).length > 0
                        ) {
                          logCheckRowData
                            .filter((x) => {
                              return x.checkIssuerErr;
                            })
                            .map((row) => {
                              if (
                                row.checkIssuer === null ||
                                row.checkIssuer == ''
                              ) {
                                return (
                                  errorArray.push(
                                    `${constantMessageData.CHECK_ISSUE_REQUIRED} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        } else {
                          errorArray &&
                            errorArray.length > 0 &&
                            errorArray.map((item, key) => {
                              if (
                                item.includes(
                                  constantMessageData.CHECK_ISSUE_REQUIRED
                                )
                              ) {
                                return (
                                  errorArray.splice(key, 1),
                                  setErrorMessages([...new Set(errorArray)]),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        }
                      };
                      return (
                        <TextBoxRender
                          {...cellInfo}
                          handleOnblurEventCheckIssue={
                            handleOnblurEventCheckIssue
                          }
                        />
                      );
                    },
                    CheckInfoCellRender: TextBoxRender,
                    CheckAmtCellRender: (cellInfo) => {
                      const logCheckRowData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckList;
                      });
                      const logCheckTabData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckTabObj;
                      });
                      const handleOnblurEventCheckAmt = () => {
                        const errorArray =
                          logCheckTabData.errorMessages &&
                          logCheckTabData.errorMessages.length > 0
                            ? logCheckTabData.errorMessages
                            : [];
                        if (
                          logCheckRowData &&
                          logCheckRowData.length > 0 &&
                          logCheckRowData.filter((x) => {
                            return x.checkAmtErr;
                          }).length > 0
                        ) {
                          logCheckRowData
                            .filter((x) => {
                              return x.checkAmtErr;
                            })
                            .map((row) => {
                              if (row.checkAmt === null || row.checkAmt === '') {
                                errorArray &&
                                  errorArray.length > 0 &&
                                  errorArray.map((item, key) => {
                                    if (
                                      item.includes(
                                        constantMessageData.CHECK_AMOUNT_ALLOW_NUMBER_REQUIRED
                                      ) 
                                      // ||
                                      // item.includes(
                                      //   constantMessageData.CHECK_AMOUNT_NON_ZERO_REQUIRED
                                      // )
                                    ) {
                                      return (
                                        errorArray.splice(key, 1),
                                        setErrorMessages([
                                          ...new Set(errorArray),
                                        ]),
                                        addEditLogCheckTab({
                                          ...logCheckTabData,
                                          disabledSaveCancelBtn: false,
                                          errorMessages: [
                                            ...new Set(errorArray),
                                          ],
                                        })
                                      );
                                    }
                                  });
                                return (
                                  errorArray.push(
                                    `${constantMessageData.CHECK_AMOUNT_REQUIRED} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                              if (
                                Number.isNaN(parseFloat(row.checkAmt)) ||
                                checkIfAmountNum(row.checkAmt) === false
                              ) {
                                errorArray &&
                                  errorArray.length > 0 &&
                                  errorArray.map((item, key) => {
                                    if (
                                      item.includes(
                                        constantMessageData.CHECK_AMOUNT_REQUIRED
                                      ) 
                                      // ||
                                      // item.includes(
                                      //   constantMessageData.CHECK_AMOUNT_NON_ZERO_REQUIRED
                                      // )
                                    ) {
                                      return (
                                        errorArray.splice(key, 1),
                                        setErrorMessages([
                                          ...new Set(errorArray),
                                        ]),
                                        addEditLogCheckTab({
                                          ...logCheckTabData,
                                          disabledSaveCancelBtn: false,
                                          errorMessages: [
                                            ...new Set(errorArray),
                                          ],
                                        })
                                      );
                                    }
                                  });
                                return (
                                  errorArray.push(
                                    `${constantMessageData.CHECK_AMOUNT_ALLOW_NUMBER_REQUIRED} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                              // if (parseFloat(row.checkAmt) <= 0) {
                              //   errorArray &&
                              //     errorArray.length > 0 &&
                              //     errorArray.map((item, key) => {
                              //       if (
                              //         item.includes(
                              //           constantMessageData.CHECK_AMOUNT_REQUIRED
                              //         ) ||
                              //         item.includes(
                              //           constantMessageData.CHECK_AMOUNT_ALLOW_NUMBER_REQUIRED
                              //         )
                              //       ) {
                              //         return (
                              //           errorArray.splice(key, 1),
                              //           setErrorMessages([
                              //             ...new Set(errorArray),
                              //           ]),
                              //           addEditLogCheckTab({
                              //             ...logCheckTabData,
                              //             disabledSaveCancelBtn: false,
                              //             errorMessages: [
                              //               ...new Set(errorArray),
                              //             ],
                              //           })
                              //         );
                              //       }
                              //     });
                              //   return (
                              //     errorArray.push(
                              //       `${constantMessageData.CHECK_AMOUNT_NON_ZERO_REQUIRED} [${row.checkLogNum}].`
                              //     ),
                              //     setErrorMessages([...new Set(errorArray)]),
                              //     setDisabledSaveCancelBtn(false),
                              //     addEditLogCheckTab({
                              //       ...logCheckTabData,
                              //       disabledSaveCancelBtn: false,
                              //       errorMessages: [...new Set(errorArray)],
                              //     })
                              //   );
                              // }
                            });
                        } else {
                          errorArray &&
                            errorArray.length > 0 &&
                            errorArray.map((item, key) => {
                              if (
                                item.includes(
                                  constantMessageData.CHECK_AMOUNT_REQUIRED
                                ) ||
                                item.includes(
                                  constantMessageData.CHECK_AMOUNT_ALLOW_NUMBER_REQUIRED
                                ) 
                                // ||
                                // item.includes(
                                //   constantMessageData.CHECK_AMOUNT_NON_ZERO_REQUIRED
                                // )
                              ) {
                                return (
                                  errorArray.splice(key, 1),
                                  setErrorMessages([...new Set(errorArray)]),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        }
                      };
                      return (
                        <TextBoxRender
                          {...cellInfo}
                          handleOnblurEventCheckAmt={handleOnblurEventCheckAmt}
                        />
                      );
                    },
                    BatchDateCellRender: (cellInfo) => {
                      const logCheckRowData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckList;
                      });
                      const logCheckTabData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckTabObj;
                      });
                      const handleOnblurEventBatchDate = () => {
                        const errorArray =
                          logCheckTabData.errorMessages &&
                          logCheckTabData.errorMessages.length > 0
                            ? logCheckTabData.errorMessages
                            : [];

                        if (
                          logCheckRowData &&
                          logCheckRowData.length > 0 &&
                          logCheckRowData.filter((x) => {
                            return x.batchDateErr;
                          }).length > 0
                        ) {
                          logCheckRowData
                            .filter((x) => {
                              return x.batchDateErr;
                            })
                            .map((row) => {
                              if (
                                row.batchDt !== null &&
                                row.batchDt !== '' &&
                                validDate(new Date(row.batchDt)) === false
                              ) {
                                return (
                                  errorArray.push(
                                    constantMessageData.DATE_INVALID_FORMAT_ERROR
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                              if (
                                row.batchDt !== null &&
                                row.batchDt !== '' &&
                                compareTwoDatesGreaterThanOrEqual(
                                  new Date(row.batchDt),
                                  moment(MinDate)
                                )
                              ) {
                                return (
                                  errorArray &&
                                    errorArray.length > 0 &&
                                    errorArray.map((item, key) => {
                                      if (
                                        item.includes(
                                          `Batch Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR}`
                                        )
                                      ) {
                                        return (
                                          errorArray.splice(key, 1),
                                          setErrorMessages([
                                            ...new Set(errorArray),
                                          ]),
                                          addEditLogCheckTab({
                                            ...logCheckTabData,
                                            disabledSaveCancelBtn: false,
                                            errorMessages: [
                                              ...new Set(errorArray),
                                            ],
                                          })
                                        );
                                      }
                                    }),
                                  errorArray.push(
                                    `${constantMessageData.BATCH_DATE_LESS_THAN_ERROR} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                              if (
                                row.batchDt !== null &&
                                row.batchDt !== '' &&
                                compareTwoDatesGreaterThanOrEqual(
                                  new Date(),
                                  moment(row.batchDt)
                                )
                              ) {
                                return (
                                  errorArray &&
                                    errorArray.length > 0 &&
                                    errorArray.map((item, key) => {
                                      if (
                                        item.includes(
                                          constantMessageData.BATCH_DATE_LESS_THAN_ERROR
                                        )
                                      ) {
                                        return (
                                          errorArray.splice(key, 1),
                                          setErrorMessages([
                                            ...new Set(errorArray),
                                          ]),
                                          addEditLogCheckTab({
                                            ...logCheckTabData,
                                            disabledSaveCancelBtn: false,
                                            errorMessages: [
                                              ...new Set(errorArray),
                                            ],
                                          })
                                        );
                                      }
                                    }),
                                  errorArray.push(
                                    `Batch Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        } else {
                          errorArray &&
                            errorArray.length > 0 &&
                            errorArray.map((item, key) => {
                              if (
                                item.includes(
                                  `Batch Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR}`
                                ) ||
                                item.includes(
                                  constantMessageData.BATCH_DATE_LESS_THAN_ERROR
                                )
                              ) {
                                return (
                                  errorArray.splice(key, 1),
                                  setErrorMessages([...new Set(errorArray)]),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        }
                      };
                      return (
                        <DatePickerRender
                          {...cellInfo}
                          gridApi={gridApi}
                          handleOnblurEventBatchDate={
                            handleOnblurEventBatchDate
                          }
                        />
                      );
                    },
                    CheckDateCellRender: (cellInfo) => {
                      const logCheckRowData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckList;
                      });
                      const logCheckTabData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckTabObj;
                      });
                      const handleOnblurEventCheckDate = () => {
                        const errorArray =
                          logCheckTabData.errorMessages &&
                          logCheckTabData.errorMessages.length > 0
                            ? logCheckTabData.errorMessages
                            : [];
                        if (
                          logCheckRowData &&
                          logCheckRowData.length > 0 &&
                          logCheckRowData.filter((x) => {
                            return x.checkDateErr;
                          }).length > 0
                        ) {
                          logCheckRowData
                            .filter((x) => {
                              return x.checkDateErr;
                            })
                            .map((row) => {
                              if (
                                row.checkDt !== null &&
                                row.checkDt !== '' &&
                                validDate(new Date(row.checkDt)) === false
                              ) {
                                return (
                                  errorArray.push(
                                    constantMessageData.DATE_INVALID_FORMAT_ERROR
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                              if (
                                row.checkDt !== null &&
                                row.checkDt !== '' &&
                                compareTwoDatesGreaterThanOrEqual(
                                  new Date(row.checkDt),
                                  moment(MinDate)
                                )
                              ) {
                                return (
                                  errorArray &&
                                    errorArray.length > 0 &&
                                    errorArray.map((item, key) => {
                                      if (
                                        item.includes(
                                          `Check Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR}`
                                        )
                                      ) {
                                        return (
                                          errorArray.splice(key, 1),
                                          setErrorMessages([
                                            ...new Set(errorArray),
                                          ]),
                                          addEditLogCheckTab({
                                            ...logCheckTabData,
                                            errorMessages: [
                                              ...new Set(errorArray),
                                            ],
                                          })
                                        );
                                      }
                                    }),
                                  errorArray.push(
                                    `${constantMessageData.CHECK_DATE_LESS_THAN_ERROR} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                              if (
                                row.checkDt !== null &&
                                row.checkDt !== '' &&
                                compareTwoDatesGreaterThanOrEqual(
                                  new Date(),
                                  moment(row.checkDt)
                                )
                              ) {
                                return (
                                  errorArray &&
                                    errorArray.length > 0 &&
                                    errorArray.map((item, key) => {
                                      if (
                                        item.includes(
                                          constantMessageData.CHECK_DATE_LESS_THAN_ERROR
                                        )
                                      ) {
                                        return (
                                          errorArray.splice(key, 1),
                                          setErrorMessages([
                                            ...new Set(errorArray),
                                          ]),
                                          addEditLogCheckTab({
                                            ...logCheckTabData,
                                            errorMessages: [
                                              ...new Set(errorArray),
                                            ],
                                          })
                                        );
                                      }
                                    }),
                                  errorArray.push(
                                    `Check Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        } else {
                          errorArray &&
                            errorArray.length > 0 &&
                            errorArray.map((item, key) => {
                              if (
                                item.includes(
                                  `Check Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR}`
                                ) ||
                                item.includes(
                                  constantMessageData.CHECK_DATE_LESS_THAN_ERROR
                                )
                              ) {
                                return (
                                  errorArray.splice(key, 1),
                                  setErrorMessages([...new Set(errorArray)]),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        }
                      };
                      return (
                        <DatePickerRender
                          {...cellInfo}
                          handleOnblurEventCheckDate={
                            handleOnblurEventCheckDate
                          }
                        />
                      );
                    },
                    PostMarkedDateCellRender: (cellInfo) => {
                      const logCheckRowData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckList;
                      });
                      const logCheckTabData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckTabObj;
                      });

                      const handleOnblurEventPostMarkedDate = () => {
                        const errorArray =
                          logCheckTabData.errorMessages &&
                          logCheckTabData.errorMessages.length > 0
                            ? logCheckTabData.errorMessages
                            : [];

                        if (
                          logCheckRowData &&
                          logCheckRowData.length > 0 &&
                          logCheckRowData.filter((x) => {
                            return x.postMarkedDateErr;
                          }).length > 0
                        ) {
                          logCheckRowData
                            .filter((x) => {
                              return x.postMarkedDateErr;
                            })
                            .map((row) => {
                              if (
                                row.postmarkedDt !== null &&
                                row.postmarkedDt !== '' &&
                                validDate(new Date(row.postmarkedDt)) === false
                              ) {
                                return (
                                  errorArray.push(
                                    constantMessageData.DATE_INVALID_FORMAT_ERROR
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                              if (
                                row.postmarkedDt !== null &&
                                row.postmarkedDt !== '' &&
                                compareTwoDatesGreaterThanOrEqual(
                                  new Date(row.postmarkedDt),
                                  moment(MinDate)
                                )
                              ) {
                                return (
                                  errorArray &&
                                    errorArray.length > 0 &&
                                    errorArray.map((item, key) => {
                                      if (
                                        item.includes(
                                          `Postmark/ EFT Transmittal Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR}`
                                        )
                                      ) {
                                        return (
                                          errorArray.splice(key, 1),
                                          setErrorMessages([
                                            ...new Set(errorArray),
                                          ]),
                                          addEditLogCheckTab({
                                            ...logCheckTabData,
                                            errorMessages: [
                                              ...new Set(errorArray),
                                            ],
                                          })
                                        );
                                      }
                                    }),
                                  errorArray.push(
                                    `${constantMessageData.POSTMARK_DATE_LESS_THAN_ERROR} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                              if (
                                row.postmarkedDt !== null &&
                                row.postmarkedDt !== '' &&
                                compareTwoDatesGreaterThanOrEqual(
                                  new Date(),
                                  moment(row.postmarkedDt)
                                )
                              ) {
                                return (
                                  errorArray &&
                                    errorArray.length > 0 &&
                                    errorArray.map((item, key) => {
                                      if (
                                        item.includes(
                                          constantMessageData.POSTMARK_DATE_LESS_THAN_ERROR
                                        )
                                      ) {
                                        return (
                                          errorArray.splice(key, 1),
                                          setErrorMessages([
                                            ...new Set(errorArray),
                                          ]),
                                          addEditLogCheckTab({
                                            ...logCheckTabData,
                                            errorMessages: [
                                              ...new Set(errorArray),
                                            ],
                                          })
                                        );
                                      }
                                    }),
                                  errorArray.push(
                                    `Postmark/ EFT Transmittal Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR} [${row.checkLogNum}].`
                                  ),
                                  setErrorMessages([...new Set(errorArray)]),
                                  setDisabledSaveCancelBtn(false),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    disabledSaveCancelBtn: false,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        } else {
                          errorArray &&
                            errorArray.length > 0 &&
                            errorArray.map((item, key) => {
                              if (
                                item.includes(
                                  `Postmark/ EFT Transmittal Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR}`
                                ) ||
                                item.includes(
                                  constantMessageData.POSTMARK_DATE_LESS_THAN_ERROR
                                )
                              ) {
                                return (
                                  errorArray.splice(key, 1),
                                  setErrorMessages([...new Set(errorArray)]),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        }
                      };
                      return (
                        <DatePickerRender
                          {...cellInfo}
                          handleOnblurEventPostMarkedDate={
                            handleOnblurEventPostMarkedDate
                          }
                        />
                      );
                    },
                    ReceivedDateCellRender: (cellInfo) => {
                      const logCheckRowData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckList;
                      });
                      const logCheckTabData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckTabObj;
                      });
                      const handleOnblurEventReceivedDate = () => {
                        const errorArray =
                          logCheckTabData.errorMessages &&
                          logCheckTabData.errorMessages.length > 0
                            ? logCheckTabData.errorMessages
                            : [];
                        if (
                          logCheckRowData &&
                          logCheckRowData.length > 0 &&
                          logCheckRowData.filter((x) => {
                            return x.receivedDateErr;
                          }).length > 0
                        ) {
                          logCheckRowData.map((row) => {
                            if (
                              row.receivedDt === null ||
                              row.receivedDt === ''
                            ) {
                              return (
                                errorArray.push(
                                  `${constantMessageData.RECEIVED_DATE_REQUIRED} [${row.checkLogNum}].`
                                ),
                                setErrorMessages([...new Set(errorArray)]),
                                setDisabledSaveCancelBtn(false),
                                addEditLogCheckTab({
                                  ...logCheckTabData,
                                  disabledSaveCancelBtn: false,
                                  errorMessages: [...new Set(errorArray)],
                                })
                              );
                            }
                            if (
                              row.receivedDt !== null &&
                              row.receivedDt !== '' &&
                              validDate(new Date(row.receivedDt)) === false
                            ) {
                              errorArray &&
                                errorArray.length > 0 &&
                                errorArray.map((item, key) => {
                                  if (
                                    item.includes(
                                      constantMessageData.RECEIVED_DATE_REQUIRED
                                    )
                                  ) {
                                    return (
                                      errorArray.splice(key, 1),
                                      setErrorMessages([
                                        ...new Set(errorArray),
                                      ]),
                                      addEditLogCheckTab({
                                        ...logCheckTabData,
                                        errorMessages: [...new Set(errorArray)],
                                      })
                                    );
                                  }
                                });
                              return (
                                errorArray.push(
                                  constantMessageData.DATE_INVALID_FORMAT_ERROR
                                ),
                                setErrorMessages([...new Set(errorArray)]),
                                setDisabledSaveCancelBtn(false),
                                addEditLogCheckTab({
                                  ...logCheckTabData,
                                  disabledSaveCancelBtn: false,
                                  errorMessages: [...new Set(errorArray)],
                                })
                              );
                            }
                            if (
                              row.receivedDt !== null &&
                              row.receivedDt !== '' &&
                              compareTwoDatesGreaterThanOrEqual(
                                new Date(row.receivedDt),
                                moment(MinDate)
                              )
                            ) {
                              return (
                                errorArray &&
                                  errorArray.length > 0 &&
                                  errorArray.map((item, key) => {
                                    if (
                                      item.includes(
                                        `Received Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR}`
                                      ) ||
                                      item.includes(
                                        constantMessageData.RECEIVED_DATE_REQUIRED
                                      )
                                    ) {
                                      return (
                                        errorArray.splice(key, 1),
                                        setErrorMessages([
                                          ...new Set(errorArray),
                                        ]),
                                        addEditLogCheckTab({
                                          ...logCheckTabData,
                                          errorMessages: [
                                            ...new Set(errorArray),
                                          ],
                                        })
                                      );
                                    }
                                  }),
                                errorArray.push(
                                  `${constantMessageData.RECEIVED_DATE_LESS_THAN_ERROR} [${row.checkLogNum}].`
                                ),
                                setErrorMessages([...new Set(errorArray)]),
                                addEditLogCheckTab({
                                  ...logCheckTabData,
                                  errorMessages: [...new Set(errorArray)],
                                })
                              );
                            }
                            if (
                              row.receivedDt !== null &&
                              row.receivedDt !== '' &&
                              compareTwoDatesGreaterThanOrEqual(
                                new Date(),
                                moment(row.receivedDt)
                              )
                            ) {
                              return (
                                errorArray &&
                                  errorArray.length > 0 &&
                                  errorArray.map((item, key) => {
                                    if (
                                      item.includes(
                                        constantMessageData.RECEIVED_DATE_LESS_THAN_ERROR
                                      ) ||
                                      item.includes(
                                        constantMessageData.RECEIVED_DATE_REQUIRED
                                      )
                                    ) {
                                      return (
                                        errorArray.splice(key, 1),
                                        setErrorMessages([
                                          ...new Set(errorArray),
                                        ]),
                                        addEditLogCheckTab({
                                          ...logCheckTabData,
                                          errorMessages: [
                                            ...new Set(errorArray),
                                          ],
                                        })
                                      );
                                    }
                                  }),
                                errorArray.push(
                                  `Received Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR} [${row.checkLogNum}].`
                                ),
                                setErrorMessages([...new Set(errorArray)]),
                                setDisabledSaveCancelBtn(false),
                                addEditLogCheckTab({
                                  ...logCheckTabData,
                                  disabledSaveCancelBtn: false,
                                  errorMessages: [...new Set(errorArray)],
                                })
                              );
                            }
                          });
                        } else {
                          errorArray &&
                            errorArray.length > 0 &&
                            errorArray.map((item, key) => {
                              if (
                                item.includes(
                                  `Received Date ${constantMessageData.FUTURE_DATE_NOT_ALLOW_ERROR}`
                                ) ||
                                item.includes(
                                  constantMessageData.RECEIVED_DATE_REQUIRED
                                ) ||
                                item.includes(
                                  constantMessageData.RECEIVED_DATE_LESS_THAN_ERROR
                                )
                              ) {
                                return (
                                  errorArray.splice(key, 1),
                                  setErrorMessages([...new Set(errorArray)]),
                                  addEditLogCheckTab({
                                    ...logCheckTabData,
                                    errorMessages: [...new Set(errorArray)],
                                  })
                                );
                              }
                            });
                        }
                      };
                      return (
                        <DatePickerRender
                          {...cellInfo}
                          handleOnblurEventReceivedDate={
                            handleOnblurEventReceivedDate
                          }
                          gridParams={gridParams}
                          columnDefs={
                            columnDefs &&
                            columnDefs.filter((x) => {
                              if (
                                generalSystemParameterDetails &&
                                generalSystemParameterDetails.length > 0 &&
                                parseInt(
                                  generalSystemParameterDetails[0]
                                    .checkLogByCcnInd
                                ) === 0
                              ) {
                                return x.headerName !== 'CCN';
                              }
                              return x;
                            })
                          }
                        />
                      );
                    },
                    DisputeResolutionCDCellRender: (cellInfo) => {
                      const logCheckRowData = useSelector((state) => {
                        return state.sharedState.CheckLogReducer.logCheckList;
                      });
                      return (
                        <SelectBoxRender
                          {...cellInfo}
                          disputeResolutionCd
                          commonDropdownList={commonDropdownList}
                          addNewRow={(e) => {
                            if (validateRequest(logCheckRowData)) {
                              fetchDataFromServer(cellInfo.data);
                              if (e && e.preventDefault) {
                                e.preventDefault();
                              }
                            } else {
                              const totalResultsElement = document.querySelector(
                                '.frr-log_chk .total-results'
                              );
                              if (totalResultsElement) {
                                totalResultsElement.setAttribute('tabindex', '-1');
                                totalResultsElement.focus();
                              }
                              if (e && e.preventDefault) {
                                e.preventDefault();
                              }
                            }
                          }}
                        />
                      );
                    },
                    PaymentMediaTypeCDCellRender: (cellInfo) => (
                      <SelectBoxRender
                        {...cellInfo}
                        paymentMediaTypeCd
                        commonDropdownList={commonDropdownList}
                      />
                    ),
                    CheckPayeeCDCellRender: (cellInfo) => (
                      <SelectBoxRender
                        {...cellInfo}
                        checkPayeeCd
                        commonDropdownList={commonDropdownList}
                      />
                    ),
                  }}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>

      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CHECK_LOG"
          keyValue={keyValue}
          isSpinner
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CHECK_LOG"
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={rowGridPrimaryKey && rowGridPrimaryKey.toString()}
        />
      ) : null}
    </div>
  );
}
export default LogCheckComponent;
